export const ROLES = {
  admin: "Admin",
  admin_unit: "Admin Unit Kerja",
  staff: "Staff",
  asisten_manager: "Asisten Manager",
  manager: "Manager",
  kepala_divisi: "Kepala Divisi",
  direksi: "Direksi",
};

// Roles yang boleh menjadi approver (Staff tidak masuk)
export const APPROVER_ROLES = ["asisten_manager", "manager", "kepala_divisi", "direksi"];

export const JADWAL_KERJA = {
  WFO: "WFO",
  WFH: "WFH",
  WFA: "WFA",
  Shift_1: "Shift 1",
  Shift_2: "Shift 2",
  Shift_3: "Shift 3",
};

export const LEAVE_TYPES = {
  cuti: "Cuti",
  sakit: "Sakit",
  izin: "Izin",
  dinas_luar: "Dinas Luar",
};

export const STATUS_LABELS = {
  pending: "Menunggu",
  approved: "Disetujui",
  rejected: "Ditolak",
};

// Effective Status Absensi
export const EFFECTIVE_STATUS = {
  ontime: "Ontime",
  terlambat: "Terlambat",
  pulang_cepat: "Pulang Cepat",
  cuti: "Cuti",
  izin: "Izin",
  sakit: "Sakit",
  dinas_luar: "Dinas Luar",
  alpha: "Alpha",
};

export const EFFECTIVE_STATUS_CLS = {
  ontime: "bg-signal-ok text-white",
  terlambat: "bg-signal-late text-white",
  pulang_cepat: "bg-signal-late text-white",
  cuti: "bg-klein text-white",
  izin: "bg-klein/70 text-white",
  sakit: "bg-klein/70 text-white",
  dinas_luar: "bg-black text-white",
  alpha: "bg-signal-late text-white",
};
